(() => {

    var PDPUpsellWrapperApp = (() => {
        function isIOS() {
            // Direct UA match for iPhone/iPod
            if (/iPhone|iPod/i.test(navigator.userAgent)) return true;

            // iPadOS 13+ spoofs Mac UA — distinguish from real Mac via pointer type
            if (/Mac/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1) {
                return window.matchMedia('(pointer: coarse)').matches;
            }

            return false;
        }
        var toggleUpsell = (element) => {
            const productForms = document.querySelectorAll('.product-form form');
            const atcButtons = document.querySelectorAll('.product-form form button[type="submit"]');
            if (!element) return;
            if (element.classList.contains('active')) {
                element.classList.remove('active');
                atcButtons.forEach(atcButton => {
                    atcButton.innerText = 'Add to cart';
                });
                productForms.forEach(productForm => {
                    productForm.querySelectorAll('[js-upsell-product-input]').forEach(input => {
                        input.remove();
                    });
                    productForm.querySelectorAll('[js-manual-more-payment]').forEach(manualMorePayment => {
                        manualMorePayment.classList.add('d-none');
                        const more_payment_href = ``;
                        manualMorePayment.setAttribute('href', more_payment_href);
                    });
                });
            } else {
                element.classList.add('active');
                atcButtons.forEach(atcButton => {
                    atcButton.innerText = 'Add both to cart';
                });
                productForms.forEach(productForm => {
                    const upsell_inputs = `
                        <input type="hidden" name="items[0][id]" value="${element.getAttribute('data-upsell-variant-id')}" js-upsell-product-input>
                        <input type="hidden" name="items[0][quantity]" value="1" js-upsell-product-input>
                        <input type="hidden" name="items[0][properties][_upsell_source]" value="PDP Upsell" js-upsell-product-input>
                    `;
                    productForm.insertAdjacentHTML('beforeend', upsell_inputs);
                    productForm.querySelectorAll('[js-manual-more-payment]').forEach(manualMorePayment => {
                        if (manualMorePayment.classList.contains('apple') && !isIOS()) {
                            return;
                        }
                        manualMorePayment.classList.remove('d-none');
                        const idInput = productForm.querySelector('input[name="id"]');
                        if (!idInput) return;
                        let quantity = 1;
                        const quantityInput = productForm.querySelector('input[name="quantity"]');
                        if (quantityInput) quantity = quantityInput.value;
                        const more_payment_href = `/cart/${idInput.value}:${quantity},${element.getAttribute('data-upsell-variant-id')}:1?checkout`;
                        manualMorePayment.setAttribute('href', more_payment_href);
                    });
                });
            }
        }
        var updateElement = (variant_id) => {
            if (!variant_id || variant_id === '') return;
            const productSection = document.querySelector('.single-product');
            if (!productSection) return;
            const section_id = productSection.getAttribute('data-section');

            fetch(`${window.location.pathname}?variant=${variant_id}&section_id=${section_id}`)
                .then(res => res.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');

                    // Grab the specific element you need from the fetched HTML
                    const newElement = doc.querySelector('.product-info--upsell-product'); 
                    const currentElement = document.querySelector('.product-info--upsell-product');

                    if (newElement && currentElement) {
                        currentElement.innerHTML = newElement.innerHTML;
                    }
                    document.querySelectorAll('[js-upsell-product-input]').forEach(element => {
                        element.remove();
                    });
                });
        }
        var initialize = () => {
            document.addEventListener('click', (event) => {
                if (event.target.closest('[js-pdp-upsell-wrapper]')) {
                    toggleUpsell(event.target.closest('[js-pdp-upsell-wrapper]'));
                }
            });
            document.addEventListener('variant:changed', (event) => {
                updateElement(event.detail.id);
            });
        }
        return {
            init: initialize
        }
    })();

    var ShippingCountdownApp = (() => {
        var intervalId = null;

        var getEndTime = () => {
            const now = new Date();
            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 15, 0, 0, 0);
        }

        var formatRemaining = (ms) => {
            if (ms <= 0) return null;
            const totalSeconds = Math.floor(ms / 1000);
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            return `${hours}h ${String(minutes).padStart(2, '0')}m`;
        }

        var isWeekend = () => {
            const day = new Date().getDay();
            return day === 0 || day === 6; // 0 = Sunday, 6 = Saturday
        }

        var updateCountdowns = () => {
            const now = new Date();
            const remaining = getEndTime() - now;
            document.querySelectorAll('[js-shipping-countdown]').forEach((widget) => {
                const textEl = widget.querySelector('[data-template]');
                if (!textEl) return;
                if (isWeekend() || remaining <= 0) {
                    widget.classList.add('d-none');
                    return;
                }
                widget.classList.remove('d-none');
                textEl.innerHTML = textEl.getAttribute('data-template').replace('((remain_time_value))', formatRemaining(remaining));
            });
        }

        var scheduleNextMidnight = () => {
            const now = new Date();
            const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
            setTimeout(() => {
                clearInterval(intervalId);
                updateCountdowns();
                intervalId = setInterval(updateCountdowns, 1000);
                scheduleNextMidnight();
            }, midnight - now);
        }

        var initialize = () => {
            updateCountdowns();
            intervalId = setInterval(updateCountdowns, 1000);
            scheduleNextMidnight();
        }

        return {
            init: initialize
        }
    })();

    var AdditionalPaymentButtonsApp = (() => {
        var initialize = () => {
            document.addEventListener('click', (e) => {
                if (!e.target.closest('[js-express-checkout-options]')) return;
                const element = e.target.closest('[js-express-checkout-options]');
                const container = document.querySelector('[js-additional-payment-buttons]');
                if (!container) return;
                container.style.maxHeight = container.scrollHeight + 'px';
                element.classList.add('d-none');
            });
        }
        return {
            init: initialize
        }
    })();

    var CartDrawerUpsellApp = (() => {
        var initialize = () => {
            document.addEventListener('click', async (e) => {
                if (!e.target.closest('[js-upsell-atc]')) return;
                const btn = e.target.closest('[js-upsell-atc]');
                const variantId = btn.dataset.variantId;
                btn.classList.add('loading');
    
                try {
                const res = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: 1,
                        properties: {
                            _upsell_source: 'Drawer Upsell'
                        },
                        sections: ['cart-drawer', 'cart-icon-bubble'],  // request section HTML
                        sections_url: window.location.pathname
                    })
                });
    
                const data = await res.json();
    
                if (!res.ok) {
                    console.error('Cart error:', data.description);
                    btn.classList.remove('loading');
                    return;
                }
    
                // Pass parsed state to CartDrawer's renderContents
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                    cartDrawer.renderContents(data);
                }
    
                } catch (err) {
                    console.error('Fetch error:', err);
                    btn.classList.remove('loading');
                }
            })
        }
        return {
            init: initialize
        }
    })();

    var App = (() => {
        var initialize = () => {
            PDPUpsellWrapperApp.init();
            ShippingCountdownApp.init();
            AdditionalPaymentButtonsApp.init();
            CartDrawerUpsellApp.init();
        }
        return {
            init: initialize
        }
    })();

    document.addEventListener('DOMContentLoaded', () => {
        App.init();
    })
})();